/**
 * Store locator (Leaflet + OpenStreetMap).
 * Places a pin per store: uses exact lat/long when given, otherwise geocodes
 * the address via Nominatim (result cached in localStorage so it isn't looked
 * up on every visit). Cards focus/pan the map to their store.
 */
(function () {
  "use strict";
  if (typeof L === "undefined") return;

  document.querySelectorAll("[data-store-locator]").forEach(setup);

  function setup(root) {
    var mapEl = root.querySelector("[data-store-map]");
    var dataEl = root.querySelector("[data-store-data]");
    if (!mapEl || !dataEl) return;

    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!stores || !stores.length) return;

    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([-23.55, -46.63], 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    var pin = L.divIcon({
      className: "store-pin",
      html: '<span class="store-pin__dot"></span>',
      iconSize: [22, 30],
      iconAnchor: [11, 30],
      popupAnchor: [0, -28]
    });

    var youPin = L.divIcon({
      className: "store-pin store-pin--you",
      html: '<span class="store-pin__dot store-pin__dot--you"></span>',
      iconSize: [22, 30],
      iconAnchor: [11, 30],
      popupAnchor: [0, -28]
    });

    var markers = [];
    var jobs = stores.map(function (s, i) {
      return resolveCoords(s).then(function (coord) {
        if (!coord) return null;
        var m = L.marker([coord.lat, coord.lng], { icon: pin }).addTo(map);
        m.bindPopup("<strong>" + esc(s.name) + "</strong><br>" + esc(s.address));
        markers[i] = m;
        return m;
      });
    });

    Promise.all(jobs).then(function () {
      var valid = markers.filter(Boolean);
      if (valid.length) {
        var group = L.featureGroup(valid);
        map.fitBounds(group.getBounds().pad(0.25));
        if (valid.length === 1) map.setView(valid[0].getLatLng(), 15);
      }
    });

    root.querySelectorAll("[data-store-index]").forEach(function (card) {
      card.querySelector(".store-card__focus").addEventListener("click", function () {
        var i = parseInt(card.getAttribute("data-store-index"), 10);
        var m = markers[i];
        root.querySelectorAll("[data-store-index]").forEach(function (c) {
          c.classList.toggle("is-active", c === card);
        });
        if (m) {
          map.setView(m.getLatLng(), 16, { animate: true });
          m.openPopup();
        }
      });
    });

    setupSearch(root, map, markers, youPin);

    // Container may have been sized after init (e.g. tab/hidden) — recalc.
    setTimeout(function () {
      map.invalidateSize();
    }, 250);
  }

  function setupSearch(root, map, markers, youPin) {
    var form = root.querySelector("[data-store-search]");
    if (!form) return;
    var input = form.querySelector("[data-store-search-input]");
    var btn = form.querySelector(".store-locator__search-btn");
    var status = root.querySelector("[data-store-search-status]");
    var listEl = root.querySelector(".store-locator__list");
    var youMarker = null;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = (input.value || "").trim();
      if (!q) return;
      setStatus("Buscando…");
      if (btn) btn.setAttribute("aria-busy", "true");

      geocode(q).then(function (coord) {
        if (btn) btn.removeAttribute("aria-busy");
        if (!coord) {
          setStatus("Endereço não encontrado. Tente incluir cidade e estado.");
          return;
        }
        if (youMarker) map.removeLayer(youMarker);
        youMarker = L.marker([coord.lat, coord.lng], { icon: youPin }).addTo(map);
        youMarker.bindPopup("Você está aqui");

        var ranked = [];
        markers.forEach(function (m, i) {
          if (!m) return;
          ranked.push({ i: i, d: map.distance([coord.lat, coord.lng], m.getLatLng()) });
        });
        ranked.sort(function (a, b) {
          return a.d - b.d;
        });

        ranked.forEach(function (item) {
          var card = root.querySelector('[data-store-index="' + item.i + '"]');
          if (!card) return;
          var distEl = card.querySelector(".store-card__distance");
          if (!distEl) {
            distEl = document.createElement("p");
            distEl.className = "store-card__distance";
            card.appendChild(distEl);
          }
          distEl.textContent = "A " + formatDist(item.d) + " de distância";
          if (listEl) listEl.appendChild(card);
        });

        if (ranked.length) {
          var nearest = markers[ranked[0].i];
          var group = L.featureGroup([youMarker, nearest]);
          map.fitBounds(group.getBounds().pad(0.3));
          setStatus("Loja mais próxima: a " + formatDist(ranked[0].d) + ".");
        } else {
          map.setView([coord.lat, coord.lng], 14);
          setStatus("");
        }
      });
    });

    function setStatus(msg) {
      if (status) status.textContent = msg;
    }
  }

  function formatDist(m) {
    if (m < 1000) return Math.round(m) + " m";
    return (m / 1000).toFixed(1).replace(".", ",") + " km";
  }

  function resolveCoords(s) {
    var lat = parseFloat(s.lat);
    var lng = parseFloat(s.lng);
    if (!isNaN(lat) && !isNaN(lng)) return Promise.resolve({ lat: lat, lng: lng });
    if (!s.address) return Promise.resolve(null);
    return geocode(s.address);
  }

  function geocode(address) {
    var key = "nina-geo:" + address;
    try {
      var cached = window.localStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}
    var url =
      "https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=br&q=" +
      encodeURIComponent(address);
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && res[0]) {
          var coord = { lat: parseFloat(res[0].lat), lng: parseFloat(res[0].lon) };
          try {
            window.localStorage.setItem(key, JSON.stringify(coord));
          } catch (e) {}
          return coord;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function esc(str) {
    var d = document.createElement("div");
    d.textContent = str || "";
    return d.innerHTML;
  }
})();
